<template>
  <div>
    <el-form
      size="mini"
      :model="listingForm"
      label-width="88px"
      ref="listingForm"
      :rules="rules"
      class="listing-form"
    >
      <el-form-item label="排课课程:" prop="course_id">
        <el-select v-model="listingForm.course_id" placeholder="请选择">
          <el-option
            v-for="item in courseList"
            :label="item.title"
            :value="item.course_id"
            :key="item.course_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="授课教师:" prop="teacher_ids">
        <el-select
          v-model="listingForm.teacher_ids"
          multiple
          style="display: none"
        ></el-select>
        <div class="mwow-common-form-multi-select">
          <div class="input-wrap">
            <p class="text">
              已添加<span class="mwow-green">{{
                listingForm.teacher_list.length
              }}</span
              >人
            </p>
            <teacher-selector
              :origin-option="conflictForm"
              :class-id="listingForm.class_id"
              :origin-data="listingForm.teacher_list"
              @change="handleTeacherSelect"
            >
              <el-button class="mwow-button success">添加</el-button>
            </teacher-selector>
          </div>
          <div class="show-wrap" v-show="listingForm.teacher_list.length > 0">
            <span
              v-for="item in listingForm.teacher_list"
              :key="item.teacher_id"
              :class="`${item.conflict ? 'mwow-red' : ''}`"
              >{{ item.name }}</span
            >
          </div>
        </div>
      </el-form-item>
      <el-form-item label="授课模式:" prop="lesson_type">
        <el-radio-group v-model="listingForm.lesson_type">
          <el-radio-button :label="1">线下 - 门店授课</el-radio-button>
          <el-radio-button :label="2">线上 - 直播授课</el-radio-button>
        </el-radio-group>
        <!-- <p
          class="mwow-yellow"
          style="font-size: 12px; line-height: 12px; margin-top: 12px"
        >
          全新直播内测中，收费规则即将上线
        </p> -->
      </el-form-item>
      <el-row v-if="listingForm.lesson_type === 1">
        <el-col :span="20">
          <el-form-item label="上课教室:">
            <el-select
              v-model="listingForm.classroom_id"
              filterable
              clearable
              placeholder="请选择"
              :filter-method="handleSearchClassRoom"
              @change="changeClassRoom"
            >
              <el-option
                v-for="item in searchClassRoomList"
                :key="item.classroom_id"
                :label="item.name"
                :value="item.classroom_id"
              >
              </el-option>
            </el-select>
            <span
              class="max-people"
              v-if="classRoomPeople !== 0 && originData.course_type !== 2"
              >最多可容纳 {{ classRoomPeople }}人</span
            >
          </el-form-item>
        </el-col>
        <el-col :span="4">
          <div class="mwow-green add-class-room" @click="showAddClassRoom">
            新增
          </div>
        </el-col>
      </el-row>
      <el-form-item
        label="开播教师:"
        v-if="listingForm.lesson_type === 2"
        prop="main_teacher_id"
      >
        <el-select v-model="listingForm.main_teacher_id" placeholder="请选择">
          <el-option
            v-for="item in listingForm.teacher_list"
            :key="item.teacher_id"
            :label="item.name"
            :value="item.teacher_id"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="排课模式:" prop="cycle_type">
        <el-radio-group v-model="listingForm.cycle_type">
          <el-radio-button :label="2">每周循环</el-radio-button>
          <el-radio-button :label="1">每天循环</el-radio-button>
          <el-radio-button :label="3" v-if="showCycle"
            >自由排课</el-radio-button
          >
        </el-radio-group>
        <el-popover
          v-if="listingForm.cycle_type === 3"
          placement="top"
          popper-class="followuppopover"
          trigger="hover"
          width="170"
        >
          <p>日历中的红点表示上方对应<br />的日期有安排课次</p>
          <i
            class="el-icon-question"
            slot="reference"
            style="
              margin: 0 0 0 8px;
              color: #bebfc0;
              font-size: 16px;
              vertical-align: text-bottom;
            "
          ></i>
        </el-popover>
      </el-form-item>
      <div v-if="listingForm.cycle_type === 2">
        <el-form-item label="开始日期:" prop="start_date">
          <!-- <el-date-picker
            v-model="listingForm.start_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker> -->
          <el-input
            v-model="listingForm.start_date"
            style="display: none"
          ></el-input>
          <single-select-calendar
            :value.sync="listingForm.start_date"
            :class-id="$route.query.id"
          ></single-select-calendar>
          <el-popover
            placement="top"
            popper-class="followuppopover"
            trigger="hover"
            width="170"
          >
            <p>日历中的红点表示上方对应<br />的日期有安排课次</p>
            <i
              class="el-icon-question"
              slot="reference"
              style="
                margin: 0 0 0 8px;
                color: #bebfc0;
                font-size: 16px;
                vertical-align: text-bottom;
              "
            ></i>
          </el-popover>
        </el-form-item>
        <div class="week-loop-wrap">
          <week-loop ref="weekLoop" @change="handleWeekLoopChange"></week-loop>
        </div>
        <el-form-item label="结束模式:" prop="end_type">
          <el-select
            v-model="listingForm.end_type"
            placeholder="请选择"
            @change="handleEndTypeChange"
          >
            <el-option label="按日期结束" :value="1"></el-option>
            <el-option label="按次数结束" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="排课次数:"
          prop="end_num"
          v-if="listingForm.end_type === 2"
        >
          <el-input
            v-model.number="listingForm.end_num"
            type="number"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="结束日期:"
          prop="end_date"
          v-if="listingForm.end_type === 1"
        >
          <el-date-picker
            v-model="listingForm.end_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
      </div>
      <div v-if="listingForm.cycle_type === 1" class="day-loop-wrap">
        <el-form-item label="开始日期:" prop="start_date">
          <!-- <el-date-picker
            v-model="listingForm.start_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
            @change="handleExpectedEnd"
          >
          </el-date-picker> -->
          <el-input
            v-model="listingForm.start_date"
            style="display: none"
          ></el-input>
          <single-select-calendar
            :value.sync="listingForm.start_date"
            :class-id="$route.query.id"
          ></single-select-calendar>
          <el-popover
            placement="top"
            popper-class="followuppopover"
            trigger="hover"
            width="170"
          >
            <p>日历中的红点表示上方对应<br />的日期有安排课次</p>
            <i
              class="el-icon-question"
              slot="reference"
              style="
                margin: 0 0 0 8px;
                color: #bebfc0;
                font-size: 16px;
                vertical-align: text-bottom;
              "
            ></i>
          </el-popover>
        </el-form-item>
        <el-row>
          <el-col :span="15">
            <el-form-item label="上课时间:">
              <step-time-range-selector
                :originStart.sync="listingForm.day_loop_start_time"
                :originEnd.sync="listingForm.day_loop_end_time"
              ></step-time-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <time-step-selector
              :oriStart.sync="listingForm.day_loop_start_time"
              :oriEnd.sync="listingForm.day_loop_end_time"
            ></time-step-selector>
          </el-col>
        </el-row>
        <el-form-item label="结束模式:" prop="end_type">
          <el-select
            v-model="listingForm.end_type"
            placeholder="请选择"
            @change="handleEndTypeChange"
          >
            <el-option label="按日期结束" :value="1"></el-option>
            <el-option label="按次数结束" :value="2"></el-option>
          </el-select>
        </el-form-item>
        <el-form-item
          label="排课次数:"
          prop="end_num"
          v-if="listingForm.end_type === 2"
        >
          <el-input
            v-model.number="listingForm.end_num"
            type="number"
            @change="handleExpectedEnd"
          ></el-input>
        </el-form-item>
        <el-form-item
          label="结束日期:"
          prop="end_date"
          v-if="listingForm.end_type === 1"
        >
          <el-date-picker
            v-model="listingForm.end_date"
            type="date"
            placeholder="选择日期"
            value-format="yyyy-MM-dd"
          >
          </el-date-picker>
        </el-form-item>
        <p
          v-if="lastDate"
          class="mwow-green"
          style="text-align: center; margin-bottom: 24px"
        >
          预计最后一次排课日期为 {{ lastDate || "-" }}
        </p>
      </div>
      <div v-if="listingForm.cycle_type === 3" class="day-free-wrap">
        <div class="static-calendar-wrap">
          <multi-select-calendar
            :days.sync="listingForm.single_days"
            :class-id="$route.query.id"
          ></multi-select-calendar>
        </div>
        <!-- <p
          class="mwow-green"
          style="text-align: center; margin: 0 24px 20px 24px"
        >
          <span v-if="listingForm.single_days.length > 0">
            已排<span
              style="margin: 0 4px"
              v-for="(item, index) in listingForm.single_days"
              :key="index"
              >{{ item }}课次
            </span>
          </span>
          <span v-else>未选日期</span>
        </p> -->
        <el-row>
          <el-col :span="15">
            <el-form-item label="上课时间:">
              <step-time-range-selector
                :originStart.sync="listingForm.single_start_time"
                :originEnd.sync="listingForm.single_end_time"
              ></step-time-range-selector>
            </el-form-item>
          </el-col>
          <el-col :span="4">
            <time-step-selector
              :oriStart.sync="listingForm.single_start_time"
              :oriEnd.sync="listingForm.single_end_time"
            ></time-step-selector>
          </el-col>
        </el-row>
      </div>
      <div class="btns">
        <el-button class="mwow-button-filled mini" @click="closeDialog"
          >取消</el-button
        >
        <el-button class="mwow-button-filled success mini" @click="saveListing"
          >保存</el-button
        >
      </div>
    </el-form>
    <!-- 冲突弹窗 -->
    <el-dialog
      title="提示"
      destroy-on-close
      :visible.sync="conflictDialogVisible"
      append-to-body
    >
      <conflict-dialog
        :conflictData="conflictDialogData"
        :visible.sync="conflictDialogVisible"
        @submit="conflictConfirm"
      ></conflict-dialog>
    </el-dialog>
    <!-- 添加教室抽屉 -->
    <el-drawer
      title="添加教室"
      :visible.sync="addClassRoomDrawerVisible"
      direction="rtl"
      :size="416"
      destroy-on-close
      append-to-body
    >
      <add-dialog
        :visible.sync="addClassRoomDrawerVisible"
        :edit-info="''"
        @addClassRoomId="classRoomAddId"
      ></add-dialog>
    </el-drawer>
  </div>
</template>
<script>
import eventBus from "@/utils/bus";
import weekLoop from "./weekLoop.vue";
import stepTimeRangeSelector from "@/components/stepTimeRangeSelector.vue";
import timeStepSelector from "@/components/timeStepSelector.vue";
import multiSelectCalendar from "./multiSelectCalendar.vue";
import teacherSelector from "../teacherSelector.vue";
import conflictDialog from "./conflictDialog.vue";
import { positivePass } from "@/utils/rules";
import { getClassCourseList } from "@/api/classManagement";
import { classroomSelectListApi } from "@/api/classRoom";
import {
  createArrange,
  createCalendarArrange,
  expectedEnd,
  conflictCheck,
} from "@/api/classSchedule";
import addDialog from "@/components/addClassRoomDialog.vue";
import { switchDetailApi } from "@/api/storeManagement";
import singleSelectCalendar from "./singleSelectCalendar.vue";

export default {
  name: "classDetailLog",
  components: {
    weekLoop,
    timeStepSelector,
    multiSelectCalendar,
    teacherSelector,
    conflictDialog,
    stepTimeRangeSelector,
    addDialog,
    singleSelectCalendar,
  },
  // @Prop() selectedTeacher!: any[];
  // @Prop() originData!: any;
  props: ["selectedTeacher", "originData"],
  data() {
    return {
      courseList: [],
      listingForm: {
        class_id: Number(this.$route.query.id),
        course_id: 0,
        teacher_ids: [],
        teacher_list: this.selectedTeacher,
        lesson_type: 1,
        main_teacher_id: 0,
        start_date: "",
        cycle_type: 2,
        cycle_step: 1,
        end_type: 1,
        end_date: "",
        end_num: 0,
        rules: [],
        single_days: [],
        day_loop_start_time: "12:00",
        day_loop_end_time: "13:00",
        single_start_time: "12:00",
        single_end_time: "13:00",
        classroom_id: "",
      },
      rules: {
        course_id: [
          { required: true, message: "请选择授课课程", trigger: "change" },
        ],
        teacher_ids: [
          { required: true, message: "请选择授课教师", trigger: "change" },
        ],
        main_teacher_id: [
          { required: true, message: "请选择开播教师", trigger: "change" },
        ],
        start_date: [
          { required: true, message: "请选择开始日期", trigger: "change" },
        ],
        end_date: [
          { required: true, message: "请选择结束日期", trigger: "change" },
        ],
        end_num: [
          { required: true, message: "请填写排课次数", trigger: "blur" },
          { validator: positivePass, trigger: "blur" },
        ],
        day_loop_start_time: [
          { required: true, message: "请选择上课开始时间", trigger: "change" },
        ],
        day_loop_end_time: [
          { required: true, message: "请选择上课结束时间", trigger: "change" },
        ],
        single_start_time: [
          { required: true, message: "请选择上课开始时间", trigger: "change" },
        ],
        single_end_time: [
          { required: true, message: "请选择上课结束时间", trigger: "change" },
        ],
      },
      conflictDialogVisible: false,
      conflictDialogData: {},
      lessonTotal: 0,
      lastDate: "",
      loading: false,
      conflictForm: {},
      searchClassRoomList: [],
      classRoomPeople: 0, // 可容纳人数
      addClassRoomDrawerVisible: false,
      classRoomFrom: {}, // 上课班级信息
      showCycle: true,
    };
  },

  created() {
    const cid = Number(this.$route.query.id);
    getClassCourseList({ class_id: cid }).then((res) => {
      if (res.error_code === 0) {
        this.courseList = res.data.list;
        if (res.data.list && res.data.list[0]) {
          this.listingForm.course_id = res.data.list[0].course_id;
        }
      }
    });
    const tids = [];
    this.selectedTeacher.map((item) => {
      tids.push(item.teacher_id);
    });
    this.listingForm.teacher_ids = tids;
    this.listingForm.main_teacher_id = tids[0];
    if (this.originData.classroom) {
      this.listingForm.classroom_id = Number(
        this.originData.classroom.classroom_id
      );
    }
    this.handleSearchClassRoom("");
    eventBus.$on("initClassRoomManagement", () => {
      this.handleSearchClassRoom("");
    });
    switchDetailApi().then((res) => {
      if (res.error_code === 0) {
        this.showCycle = res.data.free_arrange_lesson === 1;
      }
    });
  },
  beforeDestroy() {
    eventBus.$off("initClassRoomManagement");
  },
  methods: {
    classRoomAddId(id) {
      this.listingForm.classroom_id = id;
    },
    handleTeacherSelect(arr) {
      this.listingForm.teacher_list = arr;
      const ids = arr.map((item) => {
        return item.teacher_id;
      });
      this.listingForm.teacher_ids = ids;
      if (!ids.includes(this.listingForm.main_teacher_id)) {
        this.listingForm.main_teacher_id = ids[0];
      }
    },
    handleSearchClassRoom(v) {
      classroomSelectListApi({
        page: 1,
        page_size: 1000,
        name: v,
      }).then((res) => {
        if (res.error_code === 0) {
          this.searchClassRoomList = res.data.list;
          this.changeClassRoom(this.listingForm.classroom_id);
        }
      });
    },
    showAddClassRoom() {
      this.addClassRoomDrawerVisible = true;
    },
    changeClassRoom(i) {
      if (!this.listingForm.classroom_id) {
        this.classRoomPeople = 0;
      }
      this.searchClassRoomList.map((item) => {
        if (item.classroom_id === i) {
          this.classRoomPeople = item.people;
        }
      });
    },
    solveConflictForm() {
      const form = { ...this.listingForm };
      const result = {};
      if (form.cycle_type === 3) {
        // 日历
        if (
          !form.single_start_time ||
          !form.single_end_time ||
          !form.single_days
        ) {
          return null;
        }
        if (form.single_days.length === 0) {
          return false;
        }
        const stime = form.single_start_time.slice(0, 5) + ":00";
        const etime = form.single_end_time.slice(0, 5) + ":00";
        if (
          Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))
        ) {
          return null;
        }
        result.arrange_date_args = {
          start_time: form.single_start_time + ":00",
          end_time: form.single_end_time + ":00",
          dates: form.single_days,
        };
      } else {
        if (!form.start_date || !form.cycle_type || !form.cycle_step) {
          return null;
        }
        if (form.end_type === 2 && !form.end_num) {
          return null;
        }
        if (form.end_type === 1 && !form.end_date) {
          return null;
        }
        result.arrange_rule_args = {
          start_date: form.start_date,
          cycle_type: form.cycle_type,
          cycle_step: form.cycle_step,
          end_type: form.end_type,
          end_date: form.end_date,
          end_num: form.end_num,
        };
        if (form.cycle_type === 1) {
          // 按日循环
          if (!form.day_loop_start_time || !form.day_loop_end_time) {
            return null;
          }
          const stime = form.day_loop_start_time.slice(0, 5) + ":00";
          const etime = form.day_loop_end_time.slice(0, 5) + ":00";
          if (
            Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))
          ) {
            return null;
          }
          result.arrange_rule_args.rules = [
            {
              start_time: form.day_loop_start_time + ":00",
              end_time: form.day_loop_end_time + ":00",
            },
          ];
        } else if (form.cycle_type === 2) {
          // 按周循环
          const weekData = form.rules;
          if (!weekData || weekData.length === 0) {
            return null;
          }
          const pass = weekData.filter((item) => {
            return item.week_day.length === 0;
          });
          if (pass.length > 0) {
            return null;
          }
          const weekList = [];
          let weekPass = true;
          weekData.map((item) => {
            const stime = item.start_time.slice(0, 5) + ":00";
            const etime = item.end_time.slice(0, 5) + ":00";
            if (
              Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))
            ) {
              weekPass = false;
            }
            if (item.week_day.length > 1) {
              item.week_day.map((it) => {
                weekList.push({
                  week_day: it,
                  start_time: item.start_time + ":00",
                  end_time: item.end_time + ":00",
                });
              });
            } else {
              weekList.push({
                week_day: item.week_day[0],
                start_time: item.start_time + ":00",
                end_time: item.end_time + ":00",
              });
            }
          });
          if (weekPass) {
            result.arrange_rule_args.rules = weekList;
          } else {
            return null;
          }
        }
      }
      return result;
    },
    saveListing() {
      this.$refs["listingForm"].validate((valid) => {
        if (valid) {
          if (this.listingForm.cycle_type === 2) {
            const weekData = this.$refs["weekLoop"].tableData;
            if (!weekData || weekData.length === 0) {
              this.$message({
                type: "error",
                message: "请先填写按周排课的相关信息",
              });
              return false;
            }
            const pass = weekData.filter((item) => {
              return item.week_day.length === 0;
            });
            if (pass.length > 0) {
              this.$message({
                type: "error",
                message: "请完整填写按周排课的相关信息",
              });
              return false;
            }
            const weekList = {};
            weekData.map((item) => {
              if (item.week_day.length > 1) {
                item.week_day.map((it) => {
                  if (weekList[it]) {
                    weekList[it].push({
                      start_time: Number(item.start_time.replace(/:/, "")),
                      end_time: Number(item.end_time.replace(/:/, "")),
                    });
                  } else {
                    weekList[it] = [
                      {
                        start_time: Number(item.start_time.replace(/:/, "")),
                        end_time: Number(item.end_time.replace(/:/, "")),
                      },
                    ];
                  }
                });
              } else {
                if (weekList[item.week_day[0]]) {
                  weekList[item.week_day[0]].push({
                    start_time: Number(item.start_time.replace(/:/, "")),
                    end_time: Number(item.end_time.replace(/:/, "")),
                  });
                } else {
                  weekList[item.week_day[0]] = [
                    {
                      start_time: Number(item.start_time.replace(/:/, "")),
                      end_time: Number(item.end_time.replace(/:/, "")),
                    },
                  ];
                }
              }
            });
            let rangePass = true;
            for (const key in weekList) {
              weekList[key].map((item, index) => {
                weekList[key].map((it, idx) => {
                  if (index !== idx) {
                    if (
                      !(
                        item.end_time < it.start_time ||
                        item.start_time > it.end_time
                      )
                    ) {
                      rangePass = false;
                    }
                  }
                });
              });
            }
            if (!rangePass) {
              this.$message({
                type: "error",
                message: "按周排课的时间段有交叉",
              });
              return false;
            }
          }
          this.handleCheckConflict();
        }
      });
    },
    handleCheckConflict() {
      if (this.loading) {
        return false;
      }
      const params = { ...this.listingForm };
      const conflictOption = {
        class_id: params.class_id,
        teacher_ids: params.teacher_ids,
        classroom_id: Number(params.classroom_id),
        // arrange_id: params.arrange_id,
        // lesson_id: params.lesson_id,
      };
      if (params.cycle_type === 3) {
        const stime = params.single_start_time.slice(0, 5) + ":00";
        const etime = params.single_end_time.slice(0, 5) + ":00";
        if (
          Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))
        ) {
          this.$message({
            type: "warning",
            message: "上课结束时间必须大于开始时间",
          });
          return false;
        }
        if (params.single_days.length === 0) {
          this.$message({
            type: "warning",
            message: "请先选择日期",
          });
          return false;
        }
        conflictOption.arrange_date_args = {
          start_time: params.single_start_time + ":00",
          end_time: params.single_end_time + ":00",
          dates: params.single_days,
        };
      } else {
        conflictOption.arrange_rule_args = {
          start_date: params.start_date,
          cycle_type: params.cycle_type,
          cycle_step: params.cycle_step,
          end_type: params.end_type,
          end_date: params.end_date,
          end_num: params.end_num,
        };
        if (params.cycle_type === 1) {
          const stime = params.day_loop_start_time.slice(0, 5) + ":00";
          const etime = params.day_loop_end_time.slice(0, 5) + ":00";
          if (
            Number(stime.replace(/:/g, "")) >= Number(etime.replace(/:/g, ""))
          ) {
            this.$message({
              type: "warning",
              message: "上课结束时间必须大于开始时间",
            });
            return false;
          }
          conflictOption.arrange_rule_args.rules = [
            {
              start_time: params.day_loop_start_time + ":00",
              end_time: params.day_loop_end_time + ":00",
            },
          ];
        } else if (params.cycle_type === 2) {
          const weekData = this.$refs["weekLoop"].tableData;
          const weekList = [];
          let weekPass = true;
          weekData.map((item) => {
            if (item.week_day.length > 1) {
              item.week_day.map((it) => {
                const stime = item.start_time.slice(0, 5) + ":00";
                const etime = item.end_time.slice(0, 5) + ":00";
                if (
                  Number(stime.replace(/:/g, "")) >=
                  Number(etime.replace(/:/g, ""))
                ) {
                  weekPass = false;
                }
                weekList.push({
                  week_day: it,
                  start_time: item.start_time + ":00",
                  end_time: item.end_time + ":00",
                });
              });
            } else {
              const stime = item.start_time.slice(0, 5) + ":00";
              const etime = item.end_time.slice(0, 5) + ":00";
              if (
                Number(stime.replace(/:/g, "")) >=
                Number(etime.replace(/:/g, ""))
              ) {
                weekPass = false;
              }
              weekList.push({
                week_day: item.week_day[0],
                start_time: item.start_time + ":00",
                end_time: item.end_time + ":00",
              });
            }
          });
          if (weekPass) {
            conflictOption.arrange_rule_args.rules = weekList;
          } else {
            this.$message({
              type: "warning",
              message: "上课结束时间必须大于开始时间",
            });
            return false;
          }
        }
      }
      this.loading = true;
      conflictCheck(conflictOption)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
          if (res.error_code === 0) {
            if (res.data.conflict) {
              // 有冲突，展示弹窗
              this.conflictDialogVisible = true;
              this.conflictDialogData = res.data;
            } else {
              // 无冲突
              this.conflictConfirm();
            }
          }
        })
        .catch(() => {
          setTimeout(() => {
            this.loading = false;
          }, 1000);
        });
    },
    // 发起请求
    conflictConfirm() {
      const params = { ...this.listingForm };
      params.classroom_id = Number(params.classroom_id);
      if (params.cycle_type === 3) {
        // 按日历
        const option = {
          class_id: params.class_id,
          course_id: params.course_id,
          teacher_ids: params.teacher_ids,
          main_teacher_id: params.main_teacher_id,
          lesson_type: params.lesson_type,
          start_time: params.single_start_time + ":00",
          end_time: params.single_end_time + ":00",
          dates: params.single_days,
          classroom_id: Number(params.classroom_id),
        };
        createCalendarArrange(option).then((res) => {
          if (res.error_code == 0) {
            this.$message({
              type: "success",
              message: "排课成功!",
            });
            this.closeDialog();
            eventBus.$emit("class-listing-update");
          } else {
            this.$message({
              type: "error",
              message: "排课失败!" + res.message,
            });
          }
        });
      } else {
        // 循环
        delete params.teacher_list;
        delete params.single_days;
        // 结束类型
        if (params.end_type === 1) {
          delete params.end_num;
        } else if (params.end_type === 2) {
          delete params.end_date;
        }
        if (params.cycle_type === 2) {
          // 按周
          const weekData = this.$refs["weekLoop"].tableData;
          const weekList = [];
          weekData.map((item) => {
            if (item.week_day.length > 1) {
              item.week_day.map((it) => {
                weekList.push({
                  week_day: it,
                  start_time: item.start_time + ":00",
                  end_time: item.end_time + ":00",
                });
              });
            } else {
              weekList.push({
                week_day: item.week_day[0],
                start_time: item.start_time + ":00",
                end_time: item.end_time + ":00",
              });
            }
          });
          params.rules = weekList;
        } else if (params.cycle_type === 1) {
          // 按日
          params.rules = [
            {
              start_time: params.day_loop_start_time + ":00",
              end_time: params.day_loop_end_time + ":00",
            },
          ];
          delete params.day_loop_start_time;
          delete params.day_loop_end_time;
        }
        createArrange(params)
          .then((res) => {
            setTimeout(() => {
              this.loading = false;
            }, 1000);
            if (res.error_code == 0) {
              this.$message({
                type: "success",
                message: "排课成功!",
              });
              this.closeDialog();
              eventBus.$emit("class-listing-update");
            } else {
              this.$message({
                type: "error",
                message: "排课失败!" + res.message,
              });
            }
          })
          .catch(() => {
            setTimeout(() => {
              this.loading = false;
            }, 1000);
          });
      }
    },
    // 预计排课结束日期
    handleExpectedEnd() {
      const params = { ...this.listingForm };
      if (params.cycle_type !== 1) {
        return false;
      }
      this.$refs["listingForm"].validate((valid) => {
        if (valid) {
          const option = {
            start_date: params.start_date,
            cycle_type: params.cycle_type,
            cycle_step: params.cycle_step,
            end_type: params.end_type,
            end_date: params.end_date,
            end_num: params.end_num,
            rules: [
              {
                start_time: params.day_loop_start_time + ":00",
                end_time: params.day_loop_end_time + ":00",
              },
            ],
          };
          expectedEnd(option).then((res) => {
            if (res.error_code === 0) {
              this.lessonTotal = res.data.lesson_num;
              this.lastDate = res.data.end_date;
            }
          });
        } else {
          this.lastDate = "";
        }
      });
    },
    handleEndTypeChange() {
      this.listingForm.end_date = "";
      this.listingForm.end_num = 0;
      this.lastDate = "";
    },
    closeDialog() {
      this.$emit("update:visible", false);
    },
    handleWeekLoopChange(data) {
      const form = { ...this.listingForm };
      form.rules = data;
      this.listingForm.rules = data;
      this.conflictForm = this.solveConflictForm();
    },
  },
  // @Watch("listingForm.cycle_type", { immediate: false, deep: false })
  // onCycleTypeChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.start_date", { immediate: false, deep: false })
  // onFormStartDateChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.end_date", { immediate: false, deep: false })
  // onFormEndDateChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.end_num", { immediate: false, deep: false })
  // onFormEndNumChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.day_loop_start_time", { immediate: false, deep: false })
  // onFormDayLoopStartTimeChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.day_loop_end_time", { immediate: false, deep: false })
  // onFormDayLoopEndTimeChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.single_start_time", { immediate: false, deep: false })
  // onFormSingleStartTimeChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.single_end_time", { immediate: false, deep: false })
  // onFormSingleEndTimeChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  // @Watch("listingForm.single_days", { immediate: false, deep: false })
  // onFormSingleDaysChange() {
  //   this.conflictForm = this.solveConflictForm();
  // }
  watch: {
    "listingForm.cycle_type": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.start_date": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.end_date": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.end_num": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.day_loop_start_time": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.day_loop_end_time": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.single_start_time": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.single_end_time": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
    "listingForm.single_days": {
      handler(n, o) {
        this.conflictForm = this.solveConflictForm();
      },
      immediate: false,
      deep: false,
    },
  },
};
</script>
<style lang="scss" scoped>
.step-selector {
  width: 125px;
}
.listing-form {
  padding: 20px;
  /deep/ .el-select {
    width: 100% !important;
    .el-input {
      width: 100% !important;
    }
  }
  .week-loop-wrap {
    margin-bottom: 20px;
  }
  .day-loop-wrap {
    .time-range {
      width: 300px;
    }
  }
  .day-free-wrap {
    .time-range {
      width: 300px;
    }
    .static-calendar-wrap {
      width: 256px;
      margin: 24px auto;
    }
  }
  .btns {
    text-align: right;
  }
}
/deep/ .el-radio-group {
  &:last-child {
    border-radius: 0 4px 4px 0 !important;
  }
}
</style>
